import api from "../api";
import authService from "./AuthService";
import axios from "axios";

const END_POINT = "/api/leave-periods";

/**
 * This method will load all Leave Period from the database with a get http call
 * @returns {} it is returning a promise with all Leave Periods
 */
export async function getAllLeavePeriodsHttp() {
  return await api.get(`${END_POINT}`);
}

/**
 * This method will load all leave periods (without master intervention), depending of userType, dateStart and dateEnd parameters, from the database with a get http call
 *
 * @param  {String} userType
 * @param  {String} dateStart
 * @param  {String} dateEnd
 * @returns {} it is returning a promise with all leave periods depending of parameters
 */
export async function getLeavePeriodsBetweenHttp(userType, dateStart, dateEnd) {
  return await api.get(`${END_POINT}/between`, {
    params: {
      type: userType,
      start: dateStart,
      end: dateEnd,
    },
  });
}

/**
 * This method will get a leave period by user id from the database with a get http call
 *
 * @param  {long} employeeId id of the employee we want to get leave period from the database
 * @returns {} it is returning a promise. You will have 200 status if there is a leave period for employeeId.
 */
export async function getLeavePeriodsByUserIdHttp(employeeId) {
  return await api.get(`${END_POINT}/${employeeId}`);
}

/**
 * This method will fetch leave periods from the webservice Wdg2 with a get http call
 * @param  {Object - LogInUser} logInUser user dg2
 * @param {string - FirstDay} firstDay first day of desired interval with format date "yyyy-MM-dd"
 * @param {string - LastDay} lastDay last day of desired interval with format date "yyyy-MM-dd"
 */
export async function fetchAllLeavePeriodsFromDG2Http(
  logInUser,
  firstDay,
  lastDay
) {
  return await axios.get(
    `${process.env.VUE_APP_BASE_URL}${END_POINT}/dg2/${firstDay}/${lastDay}`,
    {
      headers: {
        Authorization: authService.getBearerToken(),
        "X-AUTH-TOKEN": `${logInUser.email}:${logInUser.password}`,
      },
    }
  );
}

/**
 * This method will give the number of leave-period containing 'search' with a get http call
 * @param  {String} userType only leave-period containing 'search' will be counted
 * @returns {} it is returning a promise with the number of leave-period containing 'search'
 */
export async function countLeavePeriodsByUserType(userType) {
  return await api.get(`${END_POINT}/count`, {
    params: { type: userType },
  });
}
